export const ERROR = 0
export const SUCCESS = 1
export const NOT_FOUND = 2
export const EXISTS = 3

export default undefined
